export const integrationCollectionStateEnum = {
  RUNNING: "RUNNING",
  COMPLETED: "COMPLETED",
  REJECTED: "REJECTED",
  QUEUED: "QUEUED",
  PULLED: "PULLED",
} as const;

export type IntegrationCollectionState =
  (typeof integrationCollectionStateEnum)[keyof typeof integrationCollectionStateEnum];

export const mapIntegrationCategory = (category: string): string => {
  switch (category) {
    case "Proprietary Threat Intelligence":
      return "Vendor Enrichment";
    case "Public Threat Intelligence":
      return "Public Enrichment";
    default:
      return category;
  }
};

export const PUBLIC_THREAT_INTELLIGENCE = "Public Threat Intelligence";

export const mapIntegrationName = (name: string): string => {
  switch (name) {
    case "Cisa KEV Enricher":
      return "CISA KEV";
    case "Epss Enricher":
      return "EPSS";
    case "NVD Enricher":
      return "NVD";
    case "VulnCheck KEV Enricher":
      return "VulnCheck KEV";
    case "Iru":
      return "Iru (formerly Kandji)";
    default:
      return name;
  }
};

export const ConnectionStatusEnum = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  NOT_CONNECTED: "NOT_CONNECTED",
  INTEGRATED: "INTEGRATED",
  NOT_INTEGRATED: "NOT_INTEGRATED",
  DISABLED: "DISABLED",
} as const;

export type ConnectionStatus =
  (typeof ConnectionStatusEnum)[keyof typeof ConnectionStatusEnum];
